// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"299":"6a2eba45","449":"9d1e3102","617":"266c4218","830":"e58f41b3","996":"ffe2052b"}[chunkId] + ".chunk.js";
};